<template>
    <div>
        <el-dialog
            title="上传资源"
            :visible.sync="dialogUploadResources"
            @close="onClose"
            fullscreen
            class="upload-resources-dialog"
        >
            <div class="upload-resources">
                <div class="upload-types clearfix">
                    <div class="types-left">
                        <div class="item">
                            <span class="item-txt">分类选择：</span>
                            <el-cascader
                                v-model="specializedValue"
                                style="width: 300px"
                                @change="changeResourcesClass"
                                size="medium"
                                :props="keyObj"
                                :options="specializedList"
                                clearable
                                placeholder="请选择分类"
                            ></el-cascader>
                        </div>
                        <div class="item">
                            <span class="item-txt">资源类型：</span>
                            <!--<el-select v-model="resourcesValue" placeholder="请选择" size="medium" @change="supportFunc">
                                <el-option v-for="resourceItem in resourcesType" :key="resourceItem.resource_type_id" :label="resourceItem.resource_type_name" :value="resourceItem.resource_type_id"></el-option>
                            </el-select>-->
                            <el-cascader
                                v-model="resourcesValue"
                                :options="resourcesType"
                                :props="resTypeProp"
                                clearable
                                @change="supportFunc"
                                placeholder="请选择"
                            ></el-cascader>
                            <span class="item-txt-tip" v-show="supportTypeDesc">{{
                                supportTypeDesc
                            }}</span>
                        </div>
                    </div>
                    <div class="types-right">
                        <el-button type="primary" class="upload-btn" size="medium">
                            <span>选择文件</span>
                            <input
                                type="file"
                                :accept="acceptFormat"
                                title=""
                                multiple
                                @change="chooseFile($event)"
                                name="file"
                            />
                        </el-button>
                    </div>
                </div>
                <div class="table-wrapper">
                    <el-table
                        :data="resourcesUploadTable"
                        border
                        style="width: 100%"
                        max-height="500"
                        size="medium"
                        :header-cell-style="{
                            fontWeight: 'normal',
                            color: '#333',
                            background: '#f5f7fa'
                        }"
                        class="table-content"
                        :cell-style="{ fontSize: '12px', color: '#333' }"
                    >
                        <el-table-column label="文件" width="200">
                            <template slot-scope="scope">
                                <span class="text-overflow-2" :title="scope.row.file_name">{{
                                    scope.row.file_name
                                }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="上传进度" width="200" align="center">
                            <template slot-scope="scope">
                                <el-progress
                                    :text-inside="true"
                                    :stroke-width="14"
                                    :percentage="processQueue[scope.$index]"
                                    style="margin-bottom: 5px"
                                ></el-progress>
                                <!--                                <el-progress :text-inside="true" :stroke-width="14" :percentage="processPdf[scope.$index]" v-if="processPdf[scope.$index] !== undefined"></el-progress>-->
                            </template>
                        </el-table-column>
                        <el-table-column label="标题">
                            <template slot-scope="scope">
                                <i class="iconfont commit-required">*</i>
                                <!--:class="{'is-error' : errorInput}"-->
                                <el-input
                                    v-model="scope.row.resource_title"
                                    placeholder="请输入标题"
                                    size="medium"
                                ></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column label="简介">
                            <template slot-scope="scope">
                                <i class="iconfont commit-required">*</i>
                                <el-input
                                    v-model="scope.row.resource_content"
                                    placeholder="请输入简介"
                                    size="medium"
                                ></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column label="时长/页数" width="100" align="center">
                            <template slot-scope="scope">
                                <el-input
                                    v-model="scope.row.resource_page"
                                    size="medium"
                                ></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="120" align="center">
                            <template slot-scope="scope">
                                <div
                                    style="
                                        display: flex;
                                        justify-content: center;
                                        align-items: center;
                                    "
                                >
                                    <!--                                    <el-button size="small" class="upload-btn" type="primary" v-if="!scope.row.preview_status" >-->
                                    <!--                                        <span>上传预览pdf</span>-->
                                    <!--                                        <input type="file" accept=".pdf" :name="`pdf_${scope.$index}`" @change="uploadPdfEvt($event, scope.$index)" />-->
                                    <!--                                    </el-button>-->
                                    <el-button
                                        size="small"
                                        type="danger"
                                        @click="deleteUploadRow(scope.row.file_path, scope.$index)"
                                        >删除</el-button
                                    >
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="uploadFiles">上 传</el-button>
                <el-button type="primary" @click="saveResources">保 存</el-button>
                <el-button @click="dialogUploadResources = false">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import _ from 'underscore'
import { randomString } from '@/utils/utils'
import { uploadFileApi, uploadPdf } from '@/utils/apis'
import { uploadFileFn, cancelUpload, deleteFile } from '@/utils/upload/useOss'
export default {
    data() {
        return {
            specializedValue: [],
            specializedList: [],
            keyObj: {
                label: 'rc_name',
                value: 'rc_id',
                children: 'children'
                // checkStrictly: true
            },
            resTypeProp: {
                label: 'resource_type_name',
                value: 'resource_type_id',
                children: 'children'
            },
            resourcesType: [],
            libType: 0,
            resourcesValue: '',
            resourcesUploadTable: [],
            dialogUploadResources: false,
            supportTypeDesc: '',
            acceptFormat: '.pptx, .doc, .docx, .pdf, .mp4',
            uploadIndex: 0,
            materialTypeId: 0,
            fileQueue: [],
            processQueue: [],
            totalChunks: 100,
            uploadStatus: false,
            uploadQueueStatus: [],
            processPdf: [],
            pdfQueue: [],
            pdfUploadStatus: [],
            pdfNumber: 0,
            fileLimit: 1024 * 1024 * 800

            // errorInput: 0
        }
    },
    created() {
        this.getSpecializedList()
        this.getResourcesType()
    },
    methods: {
        changeResourcesClass(value) {
            // console.log(value)
        },
        getSpecializedList() {
            this.$http.axiosGetBy(this.$api.resourceClassList, { type: 0 }, res => {
                if (res.code === 200) {
                    this.specializedList = this.getSpecializedListData(res.list)
                }
            })
        },
        getSpecializedListData(data) {
            for (let i = 0; i < data.length; i++) {
                if (data[i].children.length === 0) {
                    delete data[i].children
                } else {
                    this.getSpecializedListData(data[i].children)
                }
            }
            return data
        },
        getResourcesType() {
            this.$http.axiosGet(this.$api.resourceTypeList, res => {
                if (res.code === 200) {
                    this.resourcesType = _.map(res.list, item => {
                        if (item.children) {
                            let childs = []
                            _.each(item.children, _val => {
                                if (Number(_val.type) === 0) {
                                    let tmp = {
                                        resource_type_id: _val.id,
                                        resource_type_name: _val.name
                                    }
                                    childs.push(tmp)
                                }
                            })
                            item.children = childs
                            return item
                        } else {
                            item
                        }
                        return item
                    })
                }
            })
        },
        uploadFiles() {
            this.uploadStatus = true
            if (!this.fileQueue.length) {
                this.$message.warning('请先选择文件')
                return
            }

            // if (this.processQueue.length === this.resourcesUploadTable.length && this.pdfNumber === this.pdfQueue.length) {
            if (this.processQueue.length === this.resourcesUploadTable.length) {
                this.$message.warning('暂无待上传文件')
                return
            }

            this.fileQueue.forEach((item, index) => {
                if (!this.processQueue[index]) {
                    this.uploadFileOne(item, index)
                }
                // const file_array = item.name.split(".")
                // const file_ext = file_array[file_array.length - 1]
                // 小于 200M 的文件不走分片上传
                // if (file_ext === "pdf" || item.size < this.fileLimit) {
                //     this.uploadPdf(item, index)
                // } else {
                //     this.uploadQueueStatus[index] = true
                //     if (!this.processQueue[index]) {
                //         this.uploadFileOne(item, index)
                //     }
                // }
            })
        },
        uploadPdf(file, index, type = 0) {
            const formData = new FormData()
            formData.append('file', file)
            uploadPdf(formData, progressEvent => {
                const process = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                if (type === 1) {
                    this.$set(this.processPdf, index, process)
                } else {
                    this.$set(this.processQueue, index, process)
                }
            })
                .then(res => {
                    if (res.code === 200) {
                        if (type === 1) {
                            this.resourcesUploadTable[index].file_preview_path = res.data.url
                        } else {
                            this.resourcesUploadTable[index].file_path = res.data.url
                        }
                    } else {
                        this.$message.warning(res.msg)
                        if (type === 1) {
                            this.$set(this.processPdf, index, 0)
                        } else {
                            this.$set(this.processQueue, index, 0)
                        }
                    }
                })
                .catch(err => {
                    console.log('err', err)
                })
        },
        async uploadFileOne(file, i) {
            const res = await uploadFileFn(
                file,
                (p, cpt, client) => {
                    this.$set(this.processQueue, i, Number((p * 100).toFixed(2)))
                    if (this.resourcesUploadTable[i]) {
                        this.resourcesUploadTable[i].abr = cpt
                        this.resourcesUploadTable[i].client = client
                    }
                },
                true
            )
            if (res && res.path) {
                this.resourcesUploadTable[i].file_path = res.path
                this.resourcesUploadTable[i].file_preview_path = res.path
            }
        },
        saveResources() {
            if (this.specializedValue.length < 2) {
                this.$message.warning('分类请选择二级分类或者三级分类')
                return
            }
            if (this.resourcesValue === '') {
                this.$message.warning('请选择资源类型')
                return
            }
            if (this.resourcesUploadTable.length === 0) {
                this.$message.warning('请选择文件')
                return
            }
            // console.log("table", this.resourcesUploadTable)
            // return
            for (let i = 0; i < this.resourcesUploadTable.length; i++) {
                if (this.resourcesUploadTable[i].resource_title === '') {
                    this.$message.warning('请填入标题')
                    return
                }
                if (this.resourcesUploadTable[i].resource_content === '') {
                    this.$message.warning('请输入简介')
                    return
                }
                if (!(this.processQueue[i] === 100)) {
                    this.$message.warning('请等待上传完成')
                    return
                }
                if (
                    !this.resourcesUploadTable[i].preview_status &&
                    !this.resourcesUploadTable[i].file_preview_path.length
                ) {
                    this.$message.warning('请上传预览文件pdf')
                    return
                }
            }
            let formData = new FormData()
            formData.append('resource_type_id', this.resourcesValue[0])
            if (this.resourcesValue.length > 1) {
                formData.append('material_type_id', this.resourcesValue[1])
            }
            formData.append(
                'uploadList',
                JSON.stringify(this.resourcesUploadTable.map(({ client, abr, ...rest }) => rest))
            )
            formData.append(
                'resource_class_id',
                this.specializedValue[this.specializedValue.length - 1]
            )
            formData.append('resource_type', this.libType)
            // formData.append('resource_type_id', this.resourcesValue);
            this.$http.axiosPost(
                this.$api.saveResource,
                formData,
                res => {
                    if (res.code === 200) {
                        this.$message({
                            type: 'success',
                            duration: 500,
                            message: res.msg,
                            onClose: () => {
                                this.$emit('materialMethod')
                                this.specializedValue = []
                                this.resourcesValue = ''
                                this.resourcesUploadTable = []
                                this.dialogUploadResources = false
                            }
                        })
                    } else {
                        this.$message.warning(res.msg)
                    }
                },
                err => {
                    console.log(err)
                }
            )
        },
        uploadPdfEvt(event, index) {
            const file = event.target.files[0]
            this.pdfQueue[index] = file
            this.$set(this.processPdf, index, 0)
        },
        chooseFile(event) {
            this.pdfNumber = 0
            let fileList = event.target.files
            for (let i = 0; i < fileList.length; i++) {
                let file = fileList[i]
                this.fileQueue.push(file)
                let fileNameArray = file.name.split('.')
                let fileExt = fileNameArray[fileNameArray.length - 1]
                fileNameArray.pop()
                let filename = fileNameArray.join('.')
                const formItem = {
                    file_name: file.name,
                    resource_title: filename,
                    resource_content: filename,
                    resource_page: '',
                    file_path: '',
                    file_preview_path: '',
                    preview_status: true,
                    client: null,
                    abr: null
                }
                if (['pdf', 'mp4', 'rar', 'zip'].indexOf(fileExt.toLowerCase()) === -1) {
                    formItem.preview_status = false
                    this.pdfNumber++
                }
                this.resourcesUploadTable.push(formItem)
            }
            event.target.value = ''
        },
        async deleteUploadRow(file_path, index) {
            if (this.uploadIndex) {
                this.uploadIndex--
            }
            if (this.processQueue[index]) {
                //上传中则取消上传
                if (this.processQueue[index] < 100) {
                    await cancelUpload(
                        this.resourcesUploadTable[index].abr,
                        this.resourcesUploadTable[index].client
                    )
                }
                if (this.processQueue[index] === 100) {
                    //上传完成则删除文件
                    await deleteFile(this.resourcesUploadTable[index].file_path)
                }
                this.processQueue.splice(index, 1)
            }
            this.resourcesUploadTable.splice(index, 1)
            this.fileQueue.splice(index, 1)
        },
        supportFunc() {
            let type = Number(this.resourcesValue[0])
            switch (type) {
                case 1:
                    this.supportTypeDesc = '*支持上传资源格式：pptx/ppt/pdf'
                    this.acceptFormat = '.pptx,.pdf'
                    break
                case 2:
                    this.supportTypeDesc = '*支持上传资源格式：doc/docx/pdf'
                    this.acceptFormat = '.docx, .pdf'
                    break
                case 3:
                    this.supportTypeDesc = '*支持上传资源格式：mp4'
                    this.acceptFormat = '.mp4'
                    break
                case 4:
                    this.supportTypeDesc = '*支持上传资源格式：mp4'
                    this.acceptFormat = '.mp4'
                    break
                case 5:
                    this.supportTypeDesc = '*支持上传资源格式：doc/docx/pdf/mp4/rar/zip'
                    this.acceptFormat = '.docx, .pdf, .mp4, .rar, .zip'
                    break
            }
        },
        onClose() {
            this.specializedValue = []
            this.resourcesValue = ''
            this.resourcesUploadTable = []
            this.supportTypeDesc = ''
            this.uploadIndex = 0
            this.acceptFormat = '.pptx, .doc, .docx, .pdf, .mp4'
            this.processQueue = []
            this.uploadStatus = false
            this.uploadQueueStatus = []
            this.fileQueue = []
            this.pdfNumber = 0
            this.pdfUploadStatus = []
            this.processPdf = []
            this.pdfQueue = []
        }
    }
}
</script>

<style lang="scss" scoped>
.upload-btn {
    position: relative;
    input {
        position: absolute;
        right: 0;
        top: 0;
        height: 100%;
        opacity: 0;
        cursor: pointer;
    }
}
.upload-resources-dialog {
    ::v-deep .el-dialog {
        .el-dialog__footer {
            text-align: center;
            .el-button + .el-button {
                margin-left: 30px;
            }
        }
    }
}
.upload-resources {
    .upload-types {
        .types-left {
            float: left;
            .item {
                display: inline-block;
                margin-right: 20px;
                .item-txt {
                    margin-right: 6px;
                }
            }
        }
        .types-right {
            float: right;
        }
    }
    .table-wrapper {
        margin-top: 10px;
        .input-content {
            height: 30px;
            width: 100%;
        }
    }
}
.commit-required {
    width: 4%;
    color: #f56c6c;
    display: inline-block;
    & + .el-input {
        width: 96%;
    }
}
::v-deep .el-input.is-error {
    .el-input__inner {
        border-color: #f56c6c;
    }
}
.item-txt-tip {
    color: #f56c6c;
    margin-left: 10px;
    font-size: 12px;
}
</style>
